<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>Заголовок * (<TranslationIcon />)</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.title"
          :error-messages="errorMessages.title"
          @input="mixChangeListItemHandler($event, 'title')"
        />
      </v-col>
    </v-row>
    <v-row>
      <QuillEditorVue
        :cols="12"
        :content="listItem.data.description"
        :loading="isLoading"
        :disabled="isLoading"
        :lightMode=true
        @input="mixChangeListItemHandler($event, 'description')"
        @onChangeContent="$emit('change:descriptionForMobile', $event)"
      />
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Место проведения *</span>
        <LocationAutocomplete
          :address="listItem.data.location"
          :loading="isLoading"
          :error-messages="returnAddressError"
          @set-location="mixChangeListItemHandler($event, 'location')"
          @update-location-part="
            mixChangeListItemHandler($event.value, `location.${$event.fieldName}`)
          "
        />
      </v-col>
    </v-row>
    <v-col cols="12">
      <MediaFilePicker
        label="Изображения"
        :file-type="$options.mediaTypesByKeys.IMAGE"
        :value="listItem.data.images"
        @change="mixChangeListItemHandler($event, 'images')"
      />
    </v-col>
    <v-col cols="12">
      <MediaFilePicker
        label="Аудио *"
        :multiple="false"
        :file-type="$options.mediaTypesByKeys.AUDIO"
        :value="listItem.data.audioId"
        @change="mixChangeListItemHandler($event, 'audioId')"
      >
        <template #preview-bottom>
          <ErrorMessage :message="errorMessages.audioId" />
        </template>
      </MediaFilePicker>
    </v-col>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker.vue'
import LocationAutocomplete from '@/components/location-autocomplete'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import ErrorMessage from '@/components/error-messages/ErrorMessage'
import QuillEditorVue from '@/components/quill-editor'

export default {
  name: 'AudioguidePoint',
  mixins: [dynamicListItemMix],
  mediaTypesByKeys: mediaTypesByKeys(),
  components: {
    ErrorMessage,
    TranslationIcon,
    MediaFilePicker,
    LocationAutocomplete,
    QuillEditorVue
  },
  computed: {
    returnAddressError () {
      return this.errorMessages['location.address'] || null
    }
  }
}
</script>
